import * as React from "react";
import { useLocation } from "react-router";

export const LOCALSTORAGE_REF_KEY = "booking_ref";
export const LOCALSTORAGE_VIA_KEY = "booking_via";

const RefTracker = () => {
  const location = useLocation();
  const isInitialLoad = React.useRef(true);

  React.useEffect(() => {
    try {
      const params = new URLSearchParams(location.search || "");
      const ref = params.get("ref");
      const via = params.get("via");
      
      // On initial page load, clear params if not in URL
      // On navigation, preserve existing values and only update if params are present
      if (isInitialLoad.current) {
        // First page load - clear if not present, save if present
        if (ref != null && ref !== "") {
          localStorage.setItem(LOCALSTORAGE_REF_KEY, ref);
        } else {
          localStorage.removeItem(LOCALSTORAGE_REF_KEY);
        }
        
        if (via != null && via !== "") {
          localStorage.setItem(LOCALSTORAGE_VIA_KEY, via);
        } else {
          localStorage.removeItem(LOCALSTORAGE_VIA_KEY);
        }
        
        isInitialLoad.current = false;
      } else {
        // Navigation - only update if params are present, preserve if absent
        if (ref != null && ref !== "") {
          localStorage.setItem(LOCALSTORAGE_REF_KEY, ref);
        }
        // Don't clear ref on navigation if not in URL - preserve existing value
        
        if (via != null && via !== "") {
          localStorage.setItem(LOCALSTORAGE_VIA_KEY, via);
        }
        // Don't clear via on navigation if not in URL - preserve existing value
      }
    } catch (e) {
      // ignore
    }
  }, [location.search]);

  return null;
};

export default RefTracker;


